import React from 'react'
import InBetweenBorderGrid from '../../../../merge-common/layout/InBetweenBorderGrid'
import ConclusionItemSkeleton from './ConclusionItemSkeleton'

type Props = {
  isResultant?: boolean
}

/** A vital conclusion row while loading. Mirrors ConclusionRow: one column for the resultant, two otherwise. */
export default function ConclusionRowSkeleton({ isResultant }: Props): JSX.Element {
  if (isResultant) {
    return <ConclusionItemSkeleton personType="resultant" />
  }

  return (
    <InBetweenBorderGrid columnCount={2}>
      <ConclusionItemSkeleton personType="duplicate" />
      <ConclusionItemSkeleton personType="survivor" />
    </InBetweenBorderGrid>
  )
}
